import { deleteIssue } from '@ui/features/quote-builder/state/actions/delete-issue';

import { clearSalesRepIdIssue } from './clear-sales-rep-id';
import { configuratorQuoteLineAdded } from './configurator-quote-line-added';
import { costEstimatorOpened } from './cost-estimator-opened';
import { csrCleared } from './csr-cleared';
import { csrSet } from './csr-set';
import { customerContactSelected } from './customer-contact-selected';
import { customerPartIdChanged } from './customer-part-id-changed';
import { dialogClosed } from './dialog-closed';
import { dialogOpened } from './dialog-opened';
import { discountCodeSelected } from './discount-code-selected';
import { editableNumberFieldChanged } from './editable-number-field-changed';
import { editableSelectFieldChanged } from './editable-select-field-changed';
import { editableStringFieldChanged } from './editable-string-field-changed';
import { issueDrawerClosed } from './issue-drawer-closed';
import { issueDrawerOpened } from './issue-drawer-opened';
import { leadTimeAppliedToAllBreaks } from './lead-time-applied-to-all-breaks';
import { leadTimeNotesChanged } from './lead-time-notes-changed';
import { marketCodeSelected } from './market-code-selected';
import { operationValueChanged } from './operation-value-changed';
import { partSearchColumnsUpdated } from './part-search-columns-updated';
import { priceFieldChanged } from './price-field-changed';
import { productOptionSelected } from './product-option-selected';
import { quoteLineCreatedOptimistic } from './quote-line-created';
import {
  quoteLineDeleted,
  quoteLineDeletionFailed,
  quoteLineDeletionSucceeded,
} from './quote-line-deleted';
import {
  quoteLineEditedInConfigurator,
  quoteLineEditedInConfiguratorClosed,
} from './quote-line-edited-in-configurator';
import { quoteLineInfoCustomerOnlyToggled } from './quote-line-info-customer-only-toggled';
import { quoteLineInfoExactMatchToggled } from './quote-line-info-exact-match-toggled';
import { quoteLineInfoTabChanged } from './quote-line-info-tab-changed';
import { quoteLineInfoToggled } from './quote-line-info-toggled';
import { quoteLinePartChanged } from './quote-line-part-changed';
import { quoteLineSpecsChanged } from './quote-line-specs-changed';
import {
  quoteLineSyncFailed,
  quoteLineSyncSucceeded,
  quoteLineSyncTriggered,
} from './quote-line-synced';
import { quotePriceCreated } from './quote-price-created';
import {
  quotePriceDeleted,
  quotePriceDeletionAbandoned,
  quotePriceDeletionSucceeded,
} from './quote-price-deleted';
import {
  quoteUpdateFailed,
  quoteUpdateSucceeded,
  quoteUpdateTriggered,
} from './quote-updated';
import { rawFieldValueCleared } from './raw-field-value-cleared';
import { requirementValueChanged } from './requirement-value-changed';
import { showAllDiscountCodeToggled } from './show-all-discount-code-toggled';
import { showAllMarketCodeToggled } from './show-all-market-code-toggled';
import { upsertIssue } from './upsert-issue';

export const reducers = {
  clearSalesRepIdIssue,
  configuratorQuoteLineAdded,
  costEstimatorOpened,
  customerContactSelected,
  csrCleared,
  csrSet,
  customerPartIdChanged,
  deleteIssue,
  dialogClosed,
  dialogOpened,
  discountCodeSelected,
  editableNumberFieldChanged,
  editableSelectFieldChanged,
  editableStringFieldChanged,
  issueDrawerClosed,
  issueDrawerOpened,
  leadTimeAppliedToAllBreaks,
  leadTimeNotesChanged,
  marketCodeSelected,
  operationValueChanged,
  partSearchColumnsUpdated,
  productOptionSelected,
  quoteLineInfoToggled,
  quoteLineSpecsChanged,
  quoteLineCreatedOptimistic,
  quoteLineDeleted,
  quoteLineDeletionFailed,
  quoteLineDeletionSucceeded,
  quoteLineEditedInConfigurator,
  quoteLineEditedInConfiguratorClosed,
  quoteLineInfoTabChanged,
  quoteLineInfoCustomerOnlyToggled,
  quoteLineInfoExactMatchToggled,
  quoteLinePartChanged,
  quoteLineSyncFailed,
  quoteLineSyncSucceeded,
  quoteLineSyncTriggered,
  quotePriceCreated,
  quotePriceDeleted,
  quotePriceDeletionAbandoned,
  quotePriceDeletionSucceeded,
  quoteUpdateTriggered,
  quoteUpdateSucceeded,
  quoteUpdateFailed,
  rawFieldValueCleared,
  showAllDiscountCodeToggled,
  showAllMarketCodeToggled,
  requirementValueChanged,
  upsertIssue,
  priceFieldChanged,
};
